import { render, staticRenderFns } from "./Formular.vue?vue&type=template&id=31ef1d60&scoped=true&"
import script from "./Formular.vue?vue&type=script&lang=js&"
export * from "./Formular.vue?vue&type=script&lang=js&"
import style0 from "./Formular.vue?vue&type=style&index=0&id=31ef1d60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef1d60",
  null
  
)

export default component.exports